import React, { useEffect, useState } from "react";
import { SonicTermData } from "../../../../../common/classes/SonicTerm";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { getAuthToken } from "../../../../../redux/reducers/auth";
import {
  getPickupTermData,
  getPickupTerms,
  setFeaturedTerms,
} from "../../../../../redux/reducers/taxonomy";
import { RequestState } from "../../../../../utils/RequestState";
import FeaturedTermSettings from "../FeaturedTermSettings";

const FeaturedGameSettingsContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const auth_token = useAppSelector(getAuthToken);
  const pickupGames = useAppSelector(getPickupTermData)["games"];

  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [featuredGames, setFeaturedGames] = useState<Array<SonicTermData>>([]);
  const maximumNumber = 4;

  useEffect(() => {
    const promise = dispatch(getPickupTerms({ type: "games" }));

    promise.finally(() => {
      setIsLoading(false);
    });

    return () => {
      promise.abort();
    };
  }, []);

  useEffect(() => {
    if (pickupGames) {
      const fGames: Array<SonicTermData> = [];
      for (let i = 0; i < maximumNumber; i++) {
        if (pickupGames[i]) {
          fGames.push(pickupGames[i]);
        }
      }
      setFeaturedGames([...fGames]);
    }
  }, [pickupGames]);

  const handleChange = (value: Array<SonicTermData>) => {
    setFeaturedGames([...value]);
    setRequestState(RequestState.Pending);
  };

  const handleSubmit = () => {
    if (auth_token) {
      const ids: Array<string> = [];
      featuredGames.forEach((fGame) => {
        ids.push(fGame.id);
      });

      dispatch(
        setFeaturedTerms({ auth_token: auth_token, ids: ids, type: "games" })
      );

      setRequestState(RequestState.Success);
    }
  };

  return (
    <FeaturedTermSettings
      maximumNumber={maximumNumber}
      isLoading={isLoading}
      requestState={requestState}
      termName={"ゲーム"}
      featuredTerms={featuredGames}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
};

export default FeaturedGameSettingsContainer;
